<template>
  <div class="checkbox-container" :class="{error:error}">
    <div>
      <div v-for="(option,index) in options" :key="index" :class="{ wrap: wrap }">
        <label>
          <input
            type="checkbox"
            class="input-check"
            :value="option.val"
            v-model="selectValues"
            v-bind="$attrs"
            :disabled="disabled"
          /><span :class="{'no-label':option.label==''}">{{ option.label }}</span>
        </label>
      </div>
    </div>
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: ['options','name','modelValue', 'wrap', 'error', 'disabled'],
  setup(props, context) {
    const selectValues = computed({
      get() {
        return props.modelValue ? props.modelValue : (props.options.length === 1) ? undefined : []
      },
      set(val: any) {
        context.emit('update:modelValue', val)
        context.emit('update', val)
      }
    })

    return {
      selectValues
    }
  },
  emits: ['update:modelValue', 'update']
})
</script>


<style lang="scss" scoped>
@import '@scss/form/input-check-box.scss';
</style>
